const GENERICS = {
  hidePassword: 'Esconder senha',
  showPassword: 'Mostrar senha',
  loadingText: 'pera, que tá carregando',
  close: 'Fechar',
  goBack: 'Voltar',
  send: 'Enviar',
  confirm: 'Confirmar',
  confirmDescription: [
    'Você tem certeza?',
    'Por favor, clique para confirmar.',
  ],
  cancel: 'Cancelar',
  message:
    'Ops! Parece que você não está conectado. Tentando conectar novamente em',
  seconds: 'segundos.',
  update: 'tente de novo Agora',
  currency: 'R$',
  numberAbbreviation: 'Nº',
  networkError: {
    500: 'Por favor, tente novamente!',
    401: 'Usuário não autenticado. Realize o login novamente.',
    403: 'Você não tem permissão para realizar esta tarefa.',
  },
  errorTitle: 'Ops... Algo deu errado',
  errorDescription500: 'Por favor, tente novamente!',
  errorDescription401: 'Usuário não autenticado. Realize o login novamente.',
  errorDescription403: 'Você não tem permissão para realizar esta tarefa.',
  loadingReviewCardMessage: 'Carregando avaliações…',
  noReviewsFound: 'Nenhuma avaliação nas últimas 2 horas',
  daysOfTheWeek: {
    sunday: 'Domingo',
    monday: 'Segunda',
    tuesday: 'Terça',
    wednesday: 'Quarta',
    thursday: 'Quinta',
    friday: 'Sexta',
    saturday: 'Sábado',
  },
  validations: {
    required: 'Campo obrigatório',
    name: 'Nome completo inválido',
    nameMinLength: 'Deve conter ao menos 3 caracteres',
    phone: 'Telefone inválido',
    ddd: 'Número de DDD não existe',
    cnpj: 'CNPJ inválido',
    email: 'E-mail inválido',
    zipcode: 'CEP inválido',
    password: 'Senha inválida',
    passwordConfirmation: 'Senhas não conferem',
    radio: 'Pergunta obrigatória',
    address: {
      routeNotFound: 'Ops! Não foi possível encontrar o endereço',
      tryByName: 'Busque o nome da rua ou',
      userLocation: 'use a localização no seu celular',
      locationNotSupported: 'Ops! Não foi possível acessar seu gps',
      number: 'Número não encontrado no endereço',
    },
  },
  tooltipIconAlt: 'Ícone de informações',
  communicationModal: {
    usefulInfo: 'Essa informação foi útil?',
    likedCTA: 'GOSTEI, QUERO MAIS!',
    unlikedCTA: 'NÃO ME INTERESSO',
  },
  filter: 'Filtrar',
  filters: 'Filtros',
  apply: 'Aplicar',
  applyRangeAriaLabel: 'Clique para aplicar o período selecionado',
  removeAll: 'Remover tudo',
  erase: 'Apagar',
  removeFilters: 'Remover filtros',
  from: 'De',
  to: 'Até',
  clearDateAriaLabel: 'Limpar seleção de datas do calendário',
  clearRange: 'Limpar seleção',
  at: 'às',
  acessibility: {
    inputCalendar: 'Input para selecionar datas',
  },
  loaders: {
    brand: 'Carregando marca',
    productInfo: 'Carregando informações do produto',
    productPrice: 'Carregando preço do produto',
    productCode: 'Carregando código do produto',
    productAvailability: 'Carregando disponibilidade do produto',
    productAction: 'Carregando ações do produto',
  },
  months: {
    january: 'janeiro',
    february: 'fevereiro',
    march: 'março',
    april: 'abril',
    may: 'maio',
    june: 'junho',
    july: 'julho',
    august: 'agosto',
    september: 'setembro',
    october: 'outubro',
    november: 'novembro',
    december: 'dezembro',
  },
  customMetaTags: {
    title: 'Seu Zé Delivery - Portal do parceiro',
    description: 'Portal para gerenciar sua loja de forma fácil e rápida.',
  },
}

export default GENERICS
